import { useEffect, useRef, useState } from 'react';
import PlacePicker from './PlacePicker.jsx';
import { fromLocalInput, toLocalInput } from '../lib/format.js';

/** Organiser-only edit of the outing header. */
export default function TripSettings({
  trip,
  mapContext,
  tiles,
  onSubmit,
  onCancel,
  busy,
  error,
}) {
  const [form, setForm] = useState({
    title: trip.title,
    description: trip.description ?? '',
    organiser: trip.organiser ?? '',
    destination: trip.destination,
    meetingPoint: trip.meetingPoint,
    meetingTime: toLocalInput(trip.meetingTime),
    departureDate: toLocalInput(trip.departureDate),
    returnDate: toLocalInput(trip.returnDate),
  });
  const set = (patch) => setForm((f) => ({ ...f, ...patch }));


  const submit = (event) => {
    event.preventDefault();
    if (!form.title.trim() || !form.destination || busy) return;
    onSubmit({
      title: form.title.trim(),
      description: form.description.trim(),
      organiser: form.organiser.trim(),
      destination: form.destination,
      meetingPoint: form.meetingPoint,
      meetingTime: fromLocalInput(form.meetingTime),
      departureDate: fromLocalInput(form.departureDate),
      returnDate: fromLocalInput(form.returnDate),
    });
  };

  return (
    <form onSubmit={submit} className="stack gap-16">
      {error && <div className="toast error" style={{ borderRadius: 10 }}>⚠ <span>{error}</span></div>}

      <div className="field">
        <label htmlFor="ts-title">Nom de la sortie *</label>
        <input
          id="ts-title"
          className="input"
          value={form.title}
          onChange={(e) => set({ title: e.target.value })}
          maxLength={120}
          required
        />
      </div>

      <div className="field">
        <label htmlFor="ts-desc">Description</label>
        <textarea
          id="ts-desc"
          className="textarea"
          value={form.description}
          onChange={(e) => set({ description: e.target.value })}
          placeholder="Secteur vise, niveau, materiel collectif a prevoir..."
          maxLength={1000}
        />
      </div>

      <PlacePicker
        label="Destination (parking du site)"
        required
        value={form.destination}
        onChange={(destination) => set({ destination })}
        contextMarkers={mapContext}
        tiles={tiles}
      />

      <PlacePicker
        label="Rendez-vous avant le depart"
        value={form.meetingPoint}
        onChange={(meetingPoint) => set({ meetingPoint })}
        contextMarkers={mapContext}
        tiles={tiles}
        hint="Optionnel : local du club, parking de regroupement..."
      />

      <div className="field-row">
        <div className="field">
          <label htmlFor="ts-meet">Heure du rendez-vous</label>
          <input
            id="ts-meet"
            className="input"
            type="datetime-local"
            value={form.meetingTime}
            onChange={(e) => set({ meetingTime: e.target.value })}
          />
        </div>
        <div className="field">
          <label htmlFor="ts-org">Organisateur</label>
          <input
            id="ts-org"
            className="input"
            value={form.organiser}
            onChange={(e) => set({ organiser: e.target.value })}
            placeholder="Votre nom"
          />
        </div>
      </div>

      <div className="field-row">
        <div className="field">
          <label htmlFor="ts-dep">Date de la sortie *</label>
          <input
            id="ts-dep"
            className="input"
            type="datetime-local"
            value={form.departureDate}
            onChange={(e) => set({ departureDate: e.target.value })}
            required
          />
        </div>
        <div className="field">
          <label htmlFor="ts-ret">Retour</label>
          <input
            id="ts-ret"
            className="input"
            type="datetime-local"
            value={form.returnDate}
            onChange={(e) => set({ returnDate: e.target.value })}
          />
        </div>
      </div>

      <div className="row gap-10">
        <button type="submit" className="btn btn-primary" disabled={busy || !form.title.trim() || !form.destination}>
          {busy && <span className="spinner" />}
          Enregistrer
        </button>
        <button type="button" className="btn btn-ghost" onClick={onCancel}>Annuler</button>
      </div>
    </form>
  );
}
